import { GlobalImages } from '@flowus/common';
import { cx } from '@flowus/common/cx';
import { useOpenModal } from '@flowus/common/next-modal';
import { Tooltip } from '@flowus/common/tooltip';
import type { FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { PRODUCT_NAME } from 'src/const/title';
import { SubscribeNotification } from './subscribe-notification';

export const QuickButton: FC = () => {
  const openModal = useOpenModal();

  const openWeChatAccount = () => {
    openModal.warning({
      title: `关注 ${PRODUCT_NAME} 公众号，接收订阅推送消息`,
      colorType: 'active',
      noCancel: true,
      confirmText: '知道了',
      content: (
        <div className="flex flex-col items-center justify-center space-y-4">
          <img src={GlobalImages.qr} className="w-32 h-32" alt="" />
        </div>
      ),
    });
  };

  const openHelper = () => {
    // window.open(publicLink.subscribeRule);
    window.open(location.origin);
  };

  return (
    <div className="grid grid-cols-3 text-grey3 px-5 py-1.5 mb-2">
      {!__BUILD_IN__ && (
        <Tooltip
          onClick={openHelper}
          placement="bottom"
          popup={`返回 ${PRODUCT_NAME} 空间`}
          className="animate-click animate-hover p-1"
        >
          <Icon name="IcArrowLeft02" size="middle" />
        </Tooltip>
      )}
      <SubscribeNotification />
      {!__BUILD_IN__ && (
        <Tooltip
          placement="bottom"
          popup="微信接收订阅推送消息"
          onClick={openWeChatAccount}
          className="animate-click animate-hover p-1"
        >
          <Icon name="IcWechat" size="middle" />
        </Tooltip>
      )}
    </div>
  );
};
